





































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

import rtSelect from "@/components/couponcancel/rtSelect.vue";
import rtDatePicker from "@/components/couponcancel/rtDatePicker.vue";

const databaseModule = namespace("database");
const couponModule = namespace("coupon");

@Component({
	components: {
		rtSelect,
		rtDatePicker,
	},
})
export default class writeoffStatistics extends Vue {
	/* @databaseModule.State("writeoffActivityList") list!: any;
	@databaseModule.State("writeoffCategoryList") list2!: any; */
	@databaseModule.State("writeoffCouponCount") couponCount!: any;
	@databaseModule.State("writeoffActivityCount") activityCount!: any;

	@couponModule.State("couponCategoryList") categoryList!: any;

	list: any[] = [];
	list2: any[] = [];

	searchValue: string = ""; /* 按活动输入搜索 */
	searchValue2: string = ""; /* 按券输入搜索 */
	tabActive: Number = 0; /* 默认tab第一个 */
	startDate: string = ""; /* 活动开始时间*/
	endDate: string = ""; /* 活动结束时间*/
	startDate2: string = ""; /* 券开始时间*/
	endDate2: string = ""; /* 券结束时间*/
	sort: Number = 1; //活动 默认按时间维度排序
	sort2: Number = 1; //券 默认按时间维度排序
	// list: Array = [  /* 活动列表 */
	// 	{
	// 		title: '六一儿童节活动',
	// 		datetime: '2019.06.01',
	// 		sales: 544
	// 	},{
	// 		title: '五一劳动节',
	// 		datetime: '2019.05.01',
	// 		sales: 844
	// 	}
	// ];
	// list2: Array = [  /* 券列表 */
	// 	{
	// 		title: '六一儿童节专用券',
	// 		datetime: '2019.06.01',
	// 		sales: 544,
	// 		imgUrl: 'http://img5.imgtn.bdimg.com/it/u=159911617,3238420924&fm=26&gp=0.jpg',
	// 		money: 20
	// 	},{
	// 		title: '五一劳动节专用券',
	// 		datetime: '2019.05.01',
	// 		sales: 844,
	// 		imgUrl: 'http://img5.imgtn.bdimg.com/it/u=159911617,3238420924&fm=26&gp=0.jpg',
	// 		money: 20
	// 	}
	// ];
	couponType: String = "";
	couponOptions: Array<any> = [
		/* 券类型 假数据 */
		{ text: "券类型", value: 0 },
		{ text: "折扣券", value: 1 },
		{ text: "代金券", value: 2 },
		{ text: "通用券", value: 3 },
		{ text: "礼品券", value: 4 },
	];

	pageNum = 0;
	pageSize = 50;
	pages = 0;
	loading = false;
	finished = false;

	mounted() {
		this.getWriteOffCouponCount();
		this.getWriteOffActivityCount();
		this.tabChangeHandler();
	}
	onLoad() {
		if (this.finished) return;
		if (this.loading) return;
		this.loading = true;
		this.pageNum++;
		if (this.tabActive == 0) {
			this.getActivityList();
		} else {
			this.getCategoryList();
		}
	}
	async getActivityList() {
		// 获取活动列表
		let postData = {
			pageNum: this.pageNum,
			pageSize: this.pageSize,
			businessEntityId: this.$global.tenantId,
			couponActivityName: this.searchValue,
			writeoffStartTime: this.startDate,
			writeoffEndTime: this.endDate,
			sortType: this.sort,
		};
		const { error, success } = await this.$store.dispatch(
			"database/getWriteOffListByActivity",
			postData
		);
		this.loading = false;
		if (success) {
			this.pageNum = success.data.pageNum;
			this.pageSize = success.data.pageSize;
			this.pages = success.data.pages;
			this.list.push(...(success.data.list || []));
			if (success.data.pageNum >= success.data.pages) {
				this.finished = true;
			}
		}
	}
	async getCategoryList() {
		// 获取券列表
		let postData = {
			pageNum: this.pageNum,
			pageSize: this.pageSize,
			businessEntityId: this.$global.tenantId,
			categoryId: this.couponType,
			// couponActivityName: this.searchValue2,
			couponName: this.searchValue2,
			writeoffStartTime: this.startDate2,
			writeoffEndTime: this.endDate2,
			sortType: this.sort2,
		};
		const { error, success } = await this.$store.dispatch(
			"database/getWriteOffListByCategory",
			postData
		);
		this.loading = false;
		this.getWriteOffCouponCount();
		if (success) {
			this.pageNum = success.data.pageNum;
			this.pageSize = success.data.pageSize;
			this.pages = success.data.pages;
			this.list2.push(...(success.data.list || []));
			if (success.data.pageNum >= success.data.pages) {
				this.finished = true;
			}
		}
	}
	getWriteOffCouponCount() {
		// 获取券数量
		let postData = {
			businessEntityId: this.$global.tenantId,
			categoryId: this.couponType,
			couponName: this.searchValue2,
			writeoffStartTime: this.startDate2,
			writeoffEndTime: this.endDate2,
		};
		this.$store.dispatch("database/getWriteOffCouponCount", postData);
	}
	getWriteOffActivityCount() {
		// 获取活动数量
		let postData = {
			businessEntityId: this.$global.tenantId,
		};
		this.$store.dispatch("database/getWriteOffActivityCount", postData);
	}
	tabChangeHandler() {
		this.list = [];
		this.list2 = [];
		this.pageNum = 0;
		this.pageSize = 50;
		this.loading = false;
		this.finished = false;
		this.onLoad();
		// this.startDate='';
		// this.endDate='';
		// this.startDate2='';
		// this.endDate2='';
		// console.log(name);
		// console.log(title);
		// tab切换触发事件
		// console.log(this.tabActive);
	}
	handleStartDate(value: string) {
		// 活动开始日期触发事件
		console.log(value);
		this.startDate = value;
		if (this.endDate) {
			this.tabChangeHandler();
		}
	}
	handleEndDate(value: string) {
		// 活动结束日期触发事件
		this.endDate = value;
		if (this.startDate) {
			this.tabChangeHandler();
		}
	}
	handleStartDate2(value: string) {
		// 券开始日期触发事件
		this.startDate2 = value;
		if (this.endDate2) {
			this.tabChangeHandler();
		}
	}
	handleEndDate2(value: string) {
		// 券结束日期触发事件
		this.endDate2 = value;
		if (this.startDate2) {
			this.tabChangeHandler();
		}
	}
	dropChangeHandler(value: string) {
		// 券下拉框触发事件
		console.log(value);
		this.couponType = value;
		this.tabChangeHandler();
	}
	searchChangeHandler(value: string) {
		//活动搜索框change
		console.log(value);
		this.searchValue = value;
		this.tabChangeHandler();
	}
	searchChangeHandler2(value: string) {
		//券搜索框change
		this.searchValue2 = value;
		this.tabChangeHandler();
	}
	sortChangeHandler() {
		// 活动排序
		this.sort = this.sort === 1 ? 2 : 1;
		this.tabChangeHandler();
	}
	sortChangeHandler2() {
		// 券排序
		this.sort2 = this.sort2 === 1 ? 2 : 1;
		this.tabChangeHandler();
	}
}
